import React from "react";
import { Field } from "formik";

import styles from "./PasswordInput.module.scss";

import { FieldPropsType, PasswordInputPropsType } from "./types";
import openEyeIcon from "@/assets/icons/openEye.svg";
import closeEyeIcon from "@/assets/icons/closeEye.svg";

export const PasswordInput: React.FC<PasswordInputPropsType> = (props) => {
  const { name, focusThisInput = false, placeholder, lable, variant } = props;
  const isOutlined = variant === "outlined";

  const inputRef = React.useRef<HTMLInputElement>(null);

  const [isFocused, setIsFocused] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  React.useEffect(() => {
    if (focusThisInput) {
      inputRef.current?.focus();
    }
  }, []);

  const handleShowPassword = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setShowPassword(!showPassword);
  };

  return (
    <Field name={name}>
      {(fieldProps: FieldPropsType) => {
        const { field, meta } = fieldProps;
        const hasValue = meta.value !== meta.initialValue;
        const shouldShowLabelFocus = !isOutlined && (isFocused || hasValue);

        return (
          <div className={styles.inputWrapper}>
            <label
              htmlFor={name}
              className={`
                ${styles.label}
                ${shouldShowLabelFocus && styles.labelFocus}
                ${isOutlined ? styles.labelOutlined : ''}
              `}>
              {lable}
            </label>
            <input
              ref={inputRef}
              type={showPassword ? "text" : "password"}
              id={name}
              placeholder={isOutlined ? placeholder : ""}
              className={`
                ${styles.input}
                ${meta.touched && meta.error ? styles.error : null}
                ${shouldShowLabelFocus ? styles.inputFocus : null}
              `}
              {...field}
              onFocus={(e) => {
                setIsFocused(true);
                if ('onFocus' in field && typeof field.onFocus === 'function') {
                  field.onFocus(e);
                }
              }}
              onBlur={(e) => {
                setIsFocused(false);
                if ('onBlur' in field && typeof field.onBlur === 'function') {
                  field.onBlur(e);
                }
              }}
            />

            <button 
              type="button"
              className={styles.showPasswordButton} 
              onClick={handleShowPassword}
            >
              <img src={showPassword ? openEyeIcon : closeEyeIcon} alt="eye" />
            </button>
          </div>
        );
      }}
    </Field>
  );
};
